import type { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@material-ui/core/styles';
import { Footer } from './footer';
import { Header } from './header';

const LayoutRoot = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  height: '100%',
  paddingTop: 64
}));

const LayoutContent = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%'
}));

export const Layout: FC = () => (
  <LayoutRoot>
    <Header />
    <LayoutContent>
      <Outlet />
      <Footer />
    </LayoutContent>
  </LayoutRoot>
);
